<template>
<div id="pros" class="p-1 d-flex flex-column align-items-start pros-contianer">
    <ProComponent v-for="item in items" :key="item" :text="item" :iconClass="iconClass" />
</div>
</template>

<script>
import ProComponent from '@/components/ProComponent.vue';

export default {
    name: "ProsList",
    props: {
        items: Array,
        iconClass: String,
    },
    components: {
        ProComponent,
    }
}
</script>

<style lang="scss" scoped>
.pros-contianer {
    font-size: 2rem;
}

@media screen and (max-width: 800px) {
    .pros-contianer {
        font-size: 1.3rem;
    }
}
</style>